import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageTransition } from "@/components/PageTransition";

const Termini = () => {
  const navigate = useNavigate();

  return (
    <PageTransition>
      <div className="min-h-screen bg-background">
        <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-lg border-b border-border/50 px-4 py-3">
          <div className="flex items-center gap-3 max-w-3xl mx-auto">
            <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-full hover:bg-muted transition-colors">
              <ArrowLeft className="w-5 h-5 text-foreground" />
            </button>
            <h1 className="text-lg font-bold text-foreground">Termini di Servizio</h1>
          </div>
        </header>
        <main className="max-w-3xl mx-auto px-6 py-10 space-y-6">
          <h2 className="text-2xl font-bold text-foreground">Termini e Condizioni di Utilizzo</h2>
          <p className="text-sm text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">1. Accettazione dei termini</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Utilizzando il servizio Tecly, accetti integralmente i presenti termini e condizioni. Se non sei d'accordo con una qualsiasi parte dei termini, ti preghiamo di non utilizzare il servizio.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">2. Descrizione del servizio</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Tecly è una piattaforma dedicata alla vendita di prodotti tecnologici ricondizionati certificati. Il servizio include la consultazione di prodotti, news tecnologiche, sfondi e strumenti di confronto.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">3. Account utente</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Per utilizzare alcune funzionalità è necessario creare un account. Sei responsabile della riservatezza delle tue credenziali e di tutte le attività che si svolgono tramite il tuo account.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">4. Prodotti e garanzia</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Tutti i prodotti ricondizionati venduti su Tecly sono certificati e coperti da garanzia come indicato nella scheda prodotto. Le condizioni di garanzia specifiche sono riportate per ciascun prodotto.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">5. Proprietà intellettuale</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Tutti i contenuti presenti su Tecly, inclusi testi, immagini, loghi e grafica, sono di proprietà di Tecly o dei rispettivi titolari e sono protetti dalle leggi sul diritto d'autore.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">6. Limitazione di responsabilità</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Tecly non sarà responsabile per eventuali danni indiretti, incidentali o consequenti derivanti dall'utilizzo o dall'impossibilità di utilizzare il servizio.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">7. Legge applicabile</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              I presenti termini sono regolati dalla legge italiana. Per qualsiasi controversia sarà competente il Foro del luogo di residenza del consumatore.
            </p>
          </section>
        </main>
      </div>
    </PageTransition>
  );
};

export default Termini;
